





























import { Component, Vue, Mixins, Provide } from 'vue-property-decorator';
import { setProject } from '@/apis/tokenData';
import PricingTable from '@/components/shared/PricingTable.vue'
import EditBoxToggle from '@/components/shared/EditBoxToggle.vue'
import { ReactiveSubscribe } from '../../../services/VueTimmer';
import { db } from '../../../firebase';
import SearchMixins from '../../../mixins/searchMixins';
import { Getter } from 'vuex-class';
import { updatePrice } from '../../../apis/team.api';
@Component({
  components:{
    PricingTable,
    EditBoxToggle,
  }
})
export default class PricingControlPage extends Mixins(SearchMixins) {
  get projectId(){
    return this.$route.params.projectId
  }

  @Getter('project/marketOptions')
  markets!: string[];

  @ReactiveSubscribe<PricingControlPage,firebase.firestore.Query>(
    e => db
      .collection('pricing_server/kryptono_config/pricing_admins')
      .where("value","==",e.projectId),
    (e,set) => e.onSnapshot(snap => set(snap.docs.map(e => e.id)))
  )
  controlPairs = []

  @ReactiveSubscribe<PricingControlPage,firebase.firestore.DocumentReference>(
    e => db
      .doc('pricing_server/kryptono_config'),
    (e,set) => e.onSnapshot(snap => set(snap.exists && snap.data() || {}))
  )
  pricingConfig = {}

  get baseControlPairs(){
    return this.controlPairs.map(e => e.split("_")[0])
  }

  @ReactiveSubscribe<PricingControlPage,firebase.firestore.CollectionReference>(
    e => db.collection('pricing_server/kryptono/pairs'),
    (e,set) => e.onSnapshot(snap => set(snap.docs.map(e =>({pair:e.id,...e.data()}))))
  )
  pricings = []

  get search(){
    return this.baseControlPairs.map(coin => [
      coin,
      ...this.markets.map(e => `${coin}_${e}`)
    ]).flat().join("|")
  }

  get filteredPricing(): any[]{
    return this.filterSearch(
      this.pricings,
      e => e.pair
    )
    .filter(e => e.price > 0)
  }

  @Provide()
  submitting = {}

  mounted() {
    setProject(this.projectId, true);
  }

  onSubmitPrice(pair,value){
    Vue.set(this.submitting,pair,true)
    updatePrice({
      pair: pair,
      price: value
    })
    .catch(error => this.$popupError(error,"Fail to update price"))
    .finally(() => {
      Vue.set(this.submitting,pair,false)
    })
  }

}
